export default __webpack_public_path__ + "412785ae3a328f43b06bf0a89511116f.png";